import { Button } from "@core/components/ui/button";
import {
  DialogClose,
  DialogFooter,
} from "@core/components/ui/dialog";
import { Link } from "@remix-run/react";
import { useTranslation } from "react-i18next";

interface AddToCartMessageViewProps {
  message?: string;
  type: string;
}
export const AddToCartMessageView = ({ message = "Item added to cart successfully.", type }: AddToCartMessageViewProps) => {
  const { t } = useTranslation();
  return (
    <div>
      {message}
      <div className="flex w-full items-center justify-between space-y-2">
        <Button asChild variant="outline">
          <DialogClose>
            {t("ui.close", "Close")}
          </DialogClose>
        </Button>
        <DialogClose asChild>
        <Button asChild>
          <Link to={{
            pathname: "/cart",
            search: `?type=${type}`,
          }}>
            {t("ui.view_cart", "View Cart")}
          </Link>
        </Button>
        </DialogClose>
      </div>
      <DialogFooter>
      </DialogFooter>
    </div>
  );
}
